/* influmedia · interazioni globali */
(function () {
  'use strict';

  /* ---------- Reveal on-scroll con stagger ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var d = parseInt(en.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { en.target.classList.add('is-in'); }, d);
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Menu mobile ---------- */
  function initHeader() {
    var header = document.querySelector('.im-header');
    var burger = document.querySelector('.im-burger');
    if (!header || !burger) return;
    burger.addEventListener('click', function () {
      var open = header.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // chiudi i dropdown desktop cliccando fuori
    document.addEventListener('click', function (ev) {
      document.querySelectorAll('.im-nav details[open]').forEach(function (d) {
        if (!d.contains(ev.target)) d.removeAttribute('open');
      });
    });
  }

  /* ---------- Variant picker pagina prodotto ---------- */
  function initProduct() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var dataEl = document.getElementById('ProductJson');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var saveEl = document.querySelector('[data-save]');
    var btn = form.querySelector('[data-add-btn]');

    function money(cents) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function currentVariant() {
      var checked = form.querySelectorAll('.im-variants input:checked');
      if (!checked.length) return product.variants[0];
      var opts = Array.prototype.map.call(checked, function (i) { return i.value; });
      return product.variants.find(function (v) {
        return opts.every(function (o, ix) { return v.options[ix] === o; });
      }) || product.variants[0];
    }

    function render() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
          if (saveEl) {
            var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
            saveEl.textContent = '-' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
      }
      // aggiorna URL con la variante selezionata (deep-link)
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('.im-variants input').forEach(function (input) {
      input.addEventListener('change', render);
    });
    render();
  }

  /* ---------- Quantità carrello ---------- */
  function initCart() {
    document.querySelectorAll('.im-cart__qty').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10);
          v = b.getAttribute('data-dir') === 'up' ? v + 1 : Math.max(0, v - 1);
          input.value = v;
          if (input.form) input.form.submit();
        });
      });
    });
  }

  function init() {
    initReveal();
    initHeader();
    initProduct();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ri-osserva i nodi aggiunti dall'editor tema Shopify
  document.addEventListener('shopify:section:load', initReveal);
})();
